import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { useEffect, lazy, Suspense, useState } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
import Chatbot from './components/Chatbot';
import Home from './pages/Home';
import SaasStore from './pages/SaasStore';
import AboutUs from './pages/AboutUs';
import ContactUs from './pages/ContactUs';

// Lazy load admin routes to reduce initial bundle size
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const AdminSettings = lazy(() => import('./pages/AdminSettings'));
const SocialMediaIntegrations = lazy(() => import('./pages/SocialMediaIntegrations'));

// Loading fallback component
const LoadingFallback = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    background: 'var(--bg-primary)'
  }}>
    <div className="body-large" style={{ color: 'var(--text-muted)' }}>Loading...</div>
  </div>
);

function App() {
  const [cookiesAccepted, setCookiesAccepted] = useState(false);

  useEffect(() => {
    // Check if cookies were already accepted
    const consent = localStorage.getItem('cookieConsent');
    if (consent === 'accepted') {
      setCookiesAccepted(true);
    }

    // Listen for consent changes
    const handleStorageChange = () => {
      const consent = localStorage.getItem('cookieConsent');
      setCookiesAccepted(consent === 'accepted');
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also check periodically for same-tab changes
    const interval = setInterval(handleStorageChange, 1000);

    // Global error handler for unhandled promise rejections
    const handleUnhandledRejection = (event) => {
      console.error('Unhandled promise rejection:', event.reason);
      event.preventDefault();
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <main id="main-content">
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/saas" element={<SaasStore />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/settings" element={<AdminSettings />} />
              <Route path="/admin/social-media" element={<SocialMediaIntegrations />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <CookieConsent onAccept={() => setCookiesAccepted(true)} />
        {cookiesAccepted && <Chatbot />}
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;